import React, { Fragment } from 'react';
import Sidemenu from './Sidemenu';
import 'whatwg-fetch';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';
import { Fade } from '@material-ui/core';
import useDrawer from '../../../hooks/useDrawer';

const useStyles = createUseStyles(() => ({
  backdrop: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'fixed',
    zIndex: 15,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
}));

const SidemenuContainer = (props) => {
  const { isOpen, isMobileMode, setIsOpen, setMenuType, menuType } = useDrawer();

  const classes = useStyles();

  return (
    <Fragment>
      <Sidemenu
        {...props}
        type={menuType}
        onChangeMenuType={(type) => setMenuType(type)}
        collapsed={!isOpen}
        onMouseEnter={() => !isMobileMode && setIsOpen(true)}
        onMouseLeave={() => !isMobileMode && setIsOpen(false)}
        mobileMode={isMobileMode}
      />

      <Fade in={(menuType !== 'fixed' || isMobileMode) && isOpen} unmountOnExit>
        <div className={clsx(classes.backdrop)} onClick={() => isMobileMode && setIsOpen(false)} />
      </Fade>
    </Fragment>
  );
};

export default SidemenuContainer;
